/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const listMyGroupsParamsFirstMax = 100;

export const ListMyGroupsParams = zod.object({
  first: zod.int().min(1).max(listMyGroupsParamsFirstMax).optional(),
  after: zod.string().optional(),
});

export type ListMyGroupsParams = zod.input<typeof ListMyGroupsParams>;
export type ListMyGroupsParamsOutput = zod.output<typeof ListMyGroupsParams>;
